<template>
  <section id="prices">
    <div class="container">
      <div class="priceSection">
        <h1 class="subtitle">
          {{$t("prices.embroidery")}}
        </h1>
        <span
          class="dot"
          @click="showDialog($t('prices.modals.S.title'), $t('prices.modals.S.text') + '<br><br><img width=200px src=' + $t('prices.modals.S.imgURL') + '></img>' )"
          @mouseover="displayPrice(1)"
          @mouseleave="displaySize(1)"
        >
          <p class="innerText" v-html="dotsText[1]"></p>
        </span>
        <span
          class="dot"
          @click="showDialog($t('prices.modals.M.title'), $t('prices.modals.M.text') + '<br><br><img width=200px src=' + $t('prices.modals.M.imgURL') + '></img>')"
          @mouseover="displayPrice(2)"
          @mouseleave="displaySize(2)"
        >
          <p class="innerText" v-html="dotsText[2]"></p>
        </span>
        <span
          class="dot"
          @click="showDialog($t('prices.modals.L.title'), $t('prices.modals.L.text') + '<br><br> <img width=200px src=' + $t('prices.modals.L.imgURL') + '></img>')"
          @mouseover="displayPrice(3)"
          @mouseleave="displaySize(3)"
        >
          <p class="innerText" v-html="dotsText[3]"></p>
        </span>
        <span
          class="dot"
          @click="showDialog($t('prices.modals.XL.title'), $t('prices.modals.XL.text') + '<br><br><img width=200px src=' + $t('prices.modals.XL.imgURL') + '></img>')"
          @mouseover="displayPrice(4)"
          @mouseleave="displaySize(4)"
        >
          <p class="innerText" v-html="dotsText[4]"></p>
        </span>
        <br />
        <br />
      </div>
      <div class="priceSection2">
        <h1 class="subtitle">
          {{$t("prices.vectorization")}}
        </h1>
        <span
          class="dot"
          @click="showDialog($t('prices.modals.V1.title'), $t('prices.modals.V1.text') + '<br><img width=200px src=' + $t('prices.modals.V1.imgURL') + '></img>')"
          @mouseover="displayPrice(5)"
          @mouseleave="displaySize(5)"
        >
          <p class="innerText" v-html="dotsText[5]"></p>
        </span>
        <span
          class="dot"
          @click="showDialog($t('prices.modals.V2.title'), $t('prices.modals.V2.text') + '<br><img width=200px src=' + $t('prices.modals.V2.imgURL') + '></img>')"
          @mouseover="displayPrice(6)"
          @mouseleave="displaySize(6)"
        >
          <p class="innerText" v-html="dotsText[6]"></p>
        </span>
        <span
          class="dot"
          @click="showDialog($t('prices.modals.V3.title'), $t('prices.modals.V3.text') + '<br><img width=200px src=' + $t('prices.modals.V3.imgURL') + '></img>')"
          @mouseover="displayPrice(7)"
          @mouseleave="displaySize(7)"
        >
          <p class="innerText" v-html="dotsText[7]"></p>
        </span>
        <span
          class="dot"
          @click="showDialog($t('prices.modals.V4.title'), $t('prices.modals.V4.text') + '<br><img width=200px src=' + $t('prices.modals.V4.imgURL') + '></img>')"
          @mouseover="displayPrice(8)"
          @mouseleave="displaySize(8)"
        >
          <p class="innerText" v-html="dotsText[8]"></p>
        </span>
      </div>
    </div>
    <v-dialog />
  </section>
</template>

<script>
export default {
  data() {
    return {
      dotsText: ["XS", "S", "M", "L", "XL", "V1", "V2", "V3", "V4"],
      prices: ["10", "20", "30", "40", "50", "15", "25", "35","50"],
      sizes: ["XS", "S", "M", "L", "XL", "V1", "V2", "V3", "V4"]
    };
  },
  methods: {
    displayPrice(index) {
      let temp =
        this.prices[index] +
        "<span style='font-size:1.4rem; font-weight:500;'>€</span>";
      this.dotsText.splice(index, 1, temp);
    },
    displaySize(index) {
      this.dotsText.splice(index, 1, this.sizes[index]);
    },
    showDialog(title, text) {
      this.$modal.show("dialog", {
        title: title,
        text: text,
        buttons: [
          {
            title: this.$t("prices.modals.close")
          }
        ]
      });
    }
  }
};
</script>

<style scoped>

@media screen and(max-width: 600px){
  h2 {
    font-size: 1rem;
  }
}

h1 {
  font-family: "Neue Montreal", sans-serif;
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
}

h2 {
  font-family: "Product Sans", sans-serif;
  font-weight: 300;
  font-size: 1.8rem;
  font-style: italic;
  text-align: center;
}

#prices {
  background-color: aliceblue;
  width : 100vw;
}

.innerText {
  margin: 0;
  color: #000;
  user-select: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -45%);
}

.dot {
  font-size: 2rem;
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  transition: transform 200ms linear;
  margin: 15px;
  height: 75px;
  width: 75px;
  /*background-color: #f3b816;*/
  border-radius: 50%;
  display: inline-block;
  position: relative;
  background-color: #fbab7e;
  background-image: radial-gradient(circle at center, #f7ce68 0%, #fbab7e 120%);
  box-shadow: 2px 2px 10px #bbb;
}

.priceSection > .dot {
  transform: translateY(7px);
}

.priceSection > .dot:hover,
.dot:focus,
.dot:active {
  backface-visibility: hidden;
  transform: perspective(1px) translateZ(0) scale(1.118);
  -webkit-font-smoothing: antialiased;
  transition: transform 200ms;
  will-change: transform;
  cursor: pointer;
  font-size: 2rem;
}

.priceSection2 > .dot:hover,
.dot:focus,
.dot:active {
  backface-visibility: hidden;
  transform: perspective(1px) translateZ(0) translateY(-7px) scale(1.118);
  -webkit-font-smoothing: antialiased;
  transition: transform 200ms;
  will-change: transform;
  cursor: pointer;
  font-size: 2rem;
}

.container {
  width: 40%;
  margin: auto;
  padding: 50px 0 50px 0;
  min-height: 400px;
}

.v--modal-box .v-modal {
  max-width: 100vw !important;
  left: 0 !important;
}

h1.modalContent {
  text-align: center !important;
  margin: 15px 0 15px 0;
  max-width: 100vw;
}

p.modalContent {
  margin: 0 20px 20px 20px;
  max-width: 92vw;
  font-family: "Acre", sans-serif;
  font-weight: 300;
  text-align: justify;
}

img.modalContent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
}

</style>
